import { Pipe, PipeTransform } from '@angular/core';

/**
 * Maps a currency code (EUR, USD, …) to its symbol for display next to a
 * salary number. Unknown values pass through unchanged so we never silently
 * misrepresent what the job actually advertised — a SK job pricing in CZK
 * should still show CZK, not €.
 */
@Pipe({
  name: 'currencyDisplay',
  standalone: true,
})
export class CurrencyDisplayPipe implements PipeTransform {
  private static readonly SYMBOLS: Record<string, string> = {
    EUR: '€',
    USD: '$',
    GBP: '£',
    CZK: 'Kč',
    PLN: 'zł',
    HUF: 'Ft',
    RUB: '₽',
  };

  transform(value: string | null | undefined): string {
    if (!value) return '';
    const v = value.trim();
    if (!v) return '';
    return CurrencyDisplayPipe.SYMBOLS[v.toUpperCase()] ?? v;
  }
}
